import { cad } from "@/lib/site";

const STATUS = { pending_payment: "Awaiting payment", paid: "Paid", fulfilled: "Packed", shipped: "Shipped", expired: "Expired" };

export const OrderStatus = ({ status }) => (
  <span className={`sticker ${status === "shipped" ? "bg-sky" : status === "fulfilled" ? "bg-pink" : status === "paid" ? "bg-lime" : "bg-cloud"}`} data-testid="order-status">{STATUS[status] || status}</span>
);

export const OrderSummary = ({ order: o }) => (
  <div className="border-t border-ink/15" data-testid="order-summary">
    <ul>
      {o.items.map((i) => (
        <li key={`${i.slug}-${i.color}-${i.size}`} className="flex gap-4 border-b border-ink/10 py-4" data-testid={`order-line-${i.slug}`}>
          <div className="tile h-20 w-20 shrink-0"><img src={i.image} alt={i.name} className="h-full w-full object-cover mix-blend-multiply" /></div>
          <div className="flex flex-1 justify-between gap-3">
            <div>
              <p className="text-[15px]">{i.name}</p>
              <p className="label mt-1 !text-[10px] text-ink/60">{i.description || `${i.color} · ${i.size === "OS" ? "One size" : i.size}`} · Qty {i.qty}</p>
            </div>
            <span className="text-sm">{cad(i.line_total)}</span>
          </div>
        </li>
      ))}
    </ul>
    <dl className="space-y-2 py-5 text-sm">
      <div className="flex justify-between"><dt className="text-ink/60">Subtotal</dt><dd data-testid="order-subtotal">{cad(o.subtotal)}</dd></div>
      {o.discount > 0 && <div className="flex justify-between"><dt className="text-ink/60">Crew reward {o.discount_code}</dt><dd data-testid="order-discount">−{cad(o.discount)}</dd></div>}
      <div className="flex justify-between"><dt className="text-ink/60">Shipping</dt><dd data-testid="order-shipping">{!o.shipping ? "None" : o.shipping_fee === 0 ? "FREE" : cad(o.shipping_fee)}</dd></div>
      {o.gift_card_applied > 0 && <div className="flex justify-between"><dt className="text-ink/60">Gift card</dt><dd data-testid="order-gift-applied">−{cad(o.gift_card_applied)}</dd></div>}
      <div className="flex justify-between border-t border-ink/10 pt-3 text-base font-medium"><dt>Total (CAD)</dt><dd data-testid="order-total">{cad(o.total)}</dd></div>
    </dl>
    {o.tracking && (
      <div className="mb-5 flex flex-wrap items-center justify-between gap-4 border-[1.5px] border-ink bg-sky px-5 py-4" data-testid="order-tracking">
        <div><p className="label font-bold">Shipped with {o.tracking.carrier}</p><p className="mt-1 font-mono text-sm" data-testid="order-tracking-number">{o.tracking.number}</p></div>
        <a href={o.tracking.url} target="_blank" rel="noreferrer" className="btn btn-ink !h-11" data-testid="order-track-package">Track package</a>
      </div>
    )}
    {o.shipping ? (
      <div className="border-t border-ink/10 pt-5">
        <p className="label text-ink/60">Shipping to</p>
        <p className="mt-2 text-sm leading-relaxed" data-testid="order-address">{o.name}<br />{o.shipping.line1}{o.shipping.line2 && <>, {o.shipping.line2}</>}<br />{o.shipping.city}, {o.shipping.province} {o.shipping.postal_code}, Canada</p>
      </div>
    ) : <p className="border-t border-ink/10 pt-5 text-sm" data-testid="order-address">Gift cards only: delivered by email on the send date.</p>}
  </div>
);
